import { AxiosPromise } from 'axios';
import { Api, Form } from './types';
import { http } from '../../services';

export const Create = async ({ id }: { id: number }): Promise<AxiosPromise<Api.Response>> =>
  http.request.post(
    `/external/refund-new/online-create/${id}`,
    {},
    {
      params: {
        applicationId: id
      }
    }
  );

export const NewRefund = async ({
  values,
  id
}: {
  values: Form.NewRefund;
  id: number;
}): Promise<AxiosPromise<Api.Response>> =>
  http.request.post(`/external/refund-new/online-step2/${id}`, {
    card_number: values.card_number,
    card_owner: values.card_owner,
    bank_tin: values.bank_tin,
    bank_transit_account: values.bank_transit_account,
    bank_mfo: values.bank_mfo,
    comment: values.comment,
    phone: values.phone,
    bank_account: values.bank_account,
    review_region_id: values.review_region_id,
    review_sub_region_id: values.review_sub_region_id
  });
